import FieldAssignees from "../../../generic/assignees/assignees"

import FieldConfig from "../../../proto/field-config"
import FieldGoalAssignees_InlineValue from "./components/inline/value"
import FieldGoalAssignees_Picker from "./render/picker"

export default class FieldGoalAssignees extends FieldAssignees {

    constructor(config: FieldConfig) {
        super(config)
        this.typeLabel          = "Goal assignees"

        _.assign(this.components, {
            // InlineValueEmpty    : FieldGoalAssignees_InlineValue,
            // InlineValueNotEmpty : FieldGoalAssignees_InlineValue,

            PickerValueEmpty    : FieldGoalAssignees_InlineValue,
            PickerValueNotEmpty : FieldGoalAssignees_InlineValue,
        })

        _.assign(this.renderComponents, {
            picker              : FieldGoalAssignees_Picker,
        })
    }
}
